import { Link } from "react-router-dom";
import BrandLockup from "@/components/BrandLockup";

export const LegalLayout = ({ title, updated, children }) => {
  return (
    <div className="min-h-screen bg-[#FAF8F2] text-[#16273F]">
      <header className="border-b border-slate-200 bg-[#FAF8F2]/90 backdrop-blur-md">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center">
          <Link to="/" aria-label="Kurpfalz Automation – Startseite">
            <BrandLockup compact />
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <Link
          to="/"
          className="text-sm font-semibold text-[#9A8420] hover:text-[#7d6b1a] transition-colors"
        >
          ← Zurück zur Startseite
        </Link>

        <h1 className="mt-6 font-bold text-3xl sm:text-4xl tracking-tight">{title}</h1>
        {updated && (
          <p className="mt-2 text-sm text-slate-500">Stand: {updated}</p>
        )}

        <div className="legal-prose mt-10 space-y-6 text-[15px] leading-relaxed text-slate-700">
          {children}
        </div>
      </main>

      <footer className="border-t border-slate-200 py-10">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-xs text-slate-400 flex flex-wrap gap-x-6 gap-y-2">
          <span>© {new Date().getFullYear()} Kurpfalz Automation · eine Marke von CK &amp; Partners</span>
          <Link to="/impressum" className="hover:text-[#16273F] transition-colors">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-[#16273F] transition-colors">Datenschutz</Link>
        </div>
      </footer>
    </div>
  );
};

export default LegalLayout;
